import { createContext, useContext } from "react";
import { IAccountProductsContainerContext } from "./types";

export const AccountProductsContainerContext = createContext<IAccountProductsContainerContext | null>(
  null
);

export const useAccountProductsContainerContext = () => {
  const context = useContext(AccountProductsContainerContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
